
//get token from local storage
export const getToken = () => { 
    return localStorage.getItem('token')
}
